export const data = {
  titles: {
    propertyList: 'Property Managers',
    search: 'Search',
    filter: 'Filter'
  },
  tableHeading: {
    admin: [
      'Property Name',
      'Manager ID',
      'Manager Access Level',
      'Status',
      'Update'
    ],
    landlord: [
      'Property Name',
      'Manager Name',
      'Manager Email',
      'Manager Access Level',
      'Status',
      'Update'
    ],
    tenant: [
      'Property Name',
      'Manager ID',
      'Manager Access Level',
      'Status',
      'Update'
    ]
  },
  cta: {
    addProperty: 'Add New Property Manager'
  }
};

export const statusClass = (status, classes) => {
  if (status === 'accepted') {
    return classes.active;
  }
  if (status === 'draft') {
    return classes.draft;
  }
  if (status === 'pending') {
    return classes.inactive;
  }
  if (status === 'disabled') {
    return classes.disabled;
  }
};
export const propertiesUserType = {
  admin: 'Admin',
  landlord: 'Landlord',
  tenant: 'Tenant'
};
